import { x } from '@xstyled/styled-components';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { t } from 'ttag';
import { Button, Link } from '~/ui/buttons';
import { Flex } from '~/ui/flex/Flex';
import { LlamaModal } from '~/ui/llama-modal/LlamaModal';
import {
  FBLogo,
  G2SquareLogo,
  INLogo,
  Logo,
  TwitterLogo
} from '~/ui/logo/Logo';
import useWindowSize from 'react-use/lib/useWindowSize';
import Confetti from 'react-confetti';
import { select } from '~/lib/select';
import { useTrainingUrl } from '../useTrainingUrl';
import { LearnerTrainingStatus } from '~/data';
import { Redirect } from 'react-router';
import audioEffect from '~/assets/mp3/victory.mp3';
import { useAudioEffect } from '~/ui/audio-effect/useAudioEffect';
import styled from 'styled-components';
import DownloadIcon from '~/assets/button/download.svg';
import priceImg from '~/assets/25.png';
import { Tooltip } from '~/ui/tooltip/Tooltip';
import { postMessage } from '~/shell/PostMessage';
import { useTrainingParams } from '../useTrainingParams';
import PointOfContact from '~/ui/point-of-contact/PointOfContact';
import { TrainingState, useTrainingStore } from '~/training/state';
import { useLmsAdapter } from '~/lms';

const Download = styled(DownloadIcon)<{
  title?: string;
}>`
  width: 27px;
  height: 23px;
  position: absolute;
  margin-top: -2px;
  margin-left: -36px;

  path {
    fill: var(--color-on-accent) !important;
  }
`;

const SocilaSection = styled.div`
  margin-top: 5px;
  display: flex;
  align-items: center;
  svg {
    margin-right: 12px;
  }
  img {
    margin-right: 12px;
  }
  .G2SquareLogo {
    span {
      display: block;
      background-image: url(${priceImg});
      background-size: cover;
      width: 35px;
      height: 23px;
      position: absolute;
      margin-left: 30px;
      margin-top: -14px;
    }
  }
`;

const SocialModal = styled.div`
  z-index: 2;
  padding: 20px;
  padding-left: 0px;
  margin-left: auto;
  margin-right: auto;

  p {
    color: dark !important;
    text-align: left;
    font-family: Recoleta;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 27px */
    text-transform: capitalize;
  }

  .tooltip {
    margin-left: 280px;
    margin-top: -65px;
    position: absolute;
    width: 300px;
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
`;

const SuccessDiv = styled.div`
  display: contents;
  @media only screen and (max-width: 768px) {
    .LlamaModalOverlay {
      justify-content: start !important;
      align-items: center !important;
    }

    .LlamaModalWrapper {
      padding-top: 0px;
    }
  }

  .success-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;

    h2 {
      color: dark;
      font-family: Recoleta;
      font-size: 36px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
      text-transform: capitalize;
      margin-bottom: 20px;
    }

    @media only screen and (max-width: 768px) {
      flex-direction: column;
    }

    .left-side {
      width: 55%;
      height: 100%;
      padding-right: 40px;
      text-align: left;
      padding-left: 10px;

      @media only screen and (max-width: 768px) {
        width: 100% !important;
        padding-right: 0px !important;
        padding-left: 0px !important;
        margin-bottom: 20px;
      }

      .linkSectionScrollArea {
        position: relative;

        /* iOS hides scrollbars until scroll — fade hints that more content is below */
        &::after {
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 48px;
          pointer-events: none;
          background: linear-gradient(
            to bottom,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.9) 60%,
            #ffffff 100%
          );
          opacity: 0;
          transition: opacity 0.2s ease;
          z-index: 1;
        }

        &[data-scroll-hint='true']::after {
          opacity: 1;
        }
      }

      .linkSection {
        overflow-y: visible;
        height: auto;
        -webkit-overflow-scrolling: touch;

        &.linkSection--constrained {
          overflow-y: auto;
          height: 280px;
        }

        p {
          padding-bottom: 20px;
        }

        button {
          text-align: left;
          padding: 12px;
          font-size: 14px;
          margin-bottom: 10px;
          width: 97%;
          padding-top: 14px;
          padding-bottom: 14px;
          font-family: ralewayBold;
          text-align: center;
          max-width: 250px;
        }

        a {
          margin-bottom: 10px;
          margin-right: 10px;
          padding: 10px 30px;
          font-size: 14px;
          padding-left: 50px !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 700;
          font-family: ralewayBold;
          text-align: center;
          max-width: 250px;

          svg {
            position: relative;
            margin-bottom: -20px;
            margin-top: -5px;
          }
        }

        .notPrimary {
          opacity: 0.7;
        }

        @media only screen and (max-width: 768px) {
          max-width: 100%;

          a {
            max-width: 100% !important;
            margin-right: 0px !important;
          }

          button {
            max-width: 100% !important;
            margin-right: 0px !important;
          }
        }
      }
    }

    .oneColumn {
      .linkSection {
        a {
          margin-left: auto !important;
          margin-right: auto !important;
        }

        button {
          margin-left: auto !important;
          margin-right: auto !important;
          display: block;
        }
      }
    }

    .right-side {
      width: 45%;
      height: 100%;
      padding-left: 20px;
      text-align: left;
      padding-right: 10px;

      @media only screen and (max-width: 768px) {
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
`;

const selector = (s: TrainingState) =>
  select(
    s,
    'logoUrl',
    'status',
    'title',
    'scorePercent',
    'policies',
    'featureShowCertificate',
    'featureShowSocialShare',
    'visualFeedback',
    'certificateUrl',
    'learnerPortalUrl',
    'companyContacts',
    'featureShowNextTraining'
  );

export const Success = () => {
  const {
    logoUrl,
    status,
    title,
    scorePercent,
    policies,
    featureShowCertificate,
    featureShowSocialShare,
    visualFeedback,
    certificateUrl,
    learnerPortalUrl,
    companyContacts,
    featureShowNextTraining
  } = useTrainingStore(selector);

  const { learnerTrainingId } = useTrainingParams();
  const { width, height } = useWindowSize();
  const url = useTrainingUrl();
  const [playAudioEffect] = useAudioEffect(audioEffect);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [linkSectionScrollHint, setLinkSectionScrollHint] = useState(false);
  const [linkSectionConstrained, setLinkSectionConstrained] = useState(false);
  const linkSectionRef = useRef<HTMLDivElement>(null);
  const lms = useLmsAdapter();

  const LINK_SECTION_MAX_HEIGHT_PX = 280;

  const hasNextSteps =
    !!(learnerPortalUrl && featureShowNextTraining) ||
    !!(featureShowCertificate && certificateUrl) ||
    !!(policies && policies.length > 0) ||
    !!featureShowSocialShare;

  const isCompleted = status === LearnerTrainingStatus.Completed;

  const evaluateLinkSectionLayout = useCallback(() => {
    const el = linkSectionRef.current;
    if (!el) return;

    const naturalHeight = el.scrollHeight;

    if (!linkSectionConstrained) {
      if (naturalHeight > LINK_SECTION_MAX_HEIGHT_PX) {
        setLinkSectionConstrained(true);
      } else {
        setLinkSectionScrollHint(false);
      }
      return;
    }

    const hasOverflow = el.scrollHeight > el.clientHeight + 2;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 8;
    setLinkSectionScrollHint(hasOverflow && !atBottom);
  }, [linkSectionConstrained]);

  useEffect(() => {
    if (!isCompleted) return;

    setLinkSectionConstrained(false);
    setLinkSectionScrollHint(false);
  }, [
    isCompleted,
    policies?.length,
    featureShowCertificate,
    certificateUrl,
    featureShowNextTraining,
    learnerPortalUrl
  ]);

  useEffect(() => {
    if (!isCompleted) return;

    const el = linkSectionRef.current;
    if (!el) return;

    evaluateLinkSectionLayout();

    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    const observer = new ResizeObserver(evaluateLinkSectionLayout);
    observer.observe(el);
    return () => observer.disconnect();
  }, [isCompleted, evaluateLinkSectionLayout, linkSectionConstrained]);

  useEffect(() => {
    if (!isCompleted) return;

    try {
      playAudioEffect();
    } catch (error) {
      // Silently ignore audio effect errors
    }

    postMessage(
      learnerTrainingId || '',
      certificateUrl || '',
      'completed',
      scorePercent
    );

    if (lms.isAvailable) {
      lms.setScore(scorePercent, 100, 0);
      lms.setReachedEnd();
      lms.setPassed();
    }
  }, [isCompleted]);

  if (!isCompleted) {
    return <Redirect to={url!} />;
  }

  const rating = sessionStorage.getItem('rating');

  const dt = new Date();
  const orgId = '34755337';
  const issueMonth = dt.getMonth();
  const issueYear = dt.getFullYear();
  const linkForLinkedin = `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${
    title + ' Training'
  }&organizationId=${orgId}&issueYear=${issueYear}&issueMonth=${issueMonth}&expirationYear=${issueYear}&expirationMonth=${issueMonth}&certUrl=https://easyllama.com`;

  return (
    <SuccessDiv className="SuccessDiv">
      <x.div w="100%" h="100%" bg={'var(--color-accent-lt)'} />
      {visualFeedback && <Confetti width={width} height={height} />}
      <LlamaModal showLlama="hide">
        <Flex variant="list" p="lg" gap="md" maxW="800px" textAlign="center">
          <div className="success-container">
            <div
              className={`left-side ${
                !companyContacts || companyContacts.length === 0
                  ? 'oneColumn'
                  : ''
              }`}
              style={{
                width:
                  companyContacts && companyContacts.length > 0
                    ? '55%'
                    : '100%',
                paddingRight:
                  companyContacts && companyContacts.length > 0 ? '40px' : '0px'
              }}
            >
              <div>
                <Logo
                  src={logoUrl}
                  height="36"
                  style={{ margin: 'unset', marginBottom: '20px' }}
                />
              </div>
              {lms.isAvailable ? (
                <x.h2 fontFamily="llama">{t`One last step!`}</x.h2>
              ) : (
                <x.h2 fontFamily="llama">{t`Thanks!`}</x.h2>
              )}
              <div
                className="linkSectionScrollArea"
                data-scroll-hint={linkSectionScrollHint ? 'true' : undefined}
              >
                <div
                  className={
                    linkSectionConstrained
                      ? 'linkSection linkSection--constrained'
                      : 'linkSection'
                  }
                  ref={linkSectionRef}
                  onScroll={evaluateLinkSectionLayout}
                >
                  {lms.isAvailable ? (
                    <>
                      <p>{t`To complete this lesson, click the button below.`}</p>
                      <Button
                        key="finish_btn"
                        onClick={() => {
                          lms.setScore(scorePercent, 100, 0);
                          lms.setReachedEnd();
                          lms.setPassed();
                          setTimeout(() => {
                            // give the previous LMS calls a chance to fully complete first
                            lms.concedeControl();
                          });
                        }}
                      >{t`Click here to finish`}</Button>
                    </>
                  ) : (
                    <>
                      <p>
                        {t`Thanks for choosing us.`}{' '}
                        {hasNextSteps &&
                          t`Here are a couple of things to do next:`}
                      </p>
                      {learnerPortalUrl && featureShowNextTraining && (
                        <Link href={learnerPortalUrl} key="portal_lnk">
                          {t`Next Training`}
                        </Link>
                      )}
                    </>
                  )}

                  {featureShowCertificate && certificateUrl && (
                    <Link
                      href={certificateUrl}
                      target="_blank"
                      key="download_cert_lnk"
                      className="notPrimary"
                      onClick={() => {
                        postMessage(
                          learnerTrainingId || '',
                          certificateUrl,
                          'completed',
                          scorePercent
                        );

                        if (lms.isAvailable) {
                          lms.setScore(scorePercent, 100, 0);
                          lms.setReachedEnd();
                          lms.setPassed();
                          setTimeout(() => {
                            lms.concedeControl();
                          });
                        }
                      }}
                    >
                      <Download />
                      {t`Download Certificate`}
                    </Link>
                  )}
                  {(policies || []).map((p, i) => (
                    <Link
                      key={`policy_lnk_${i}`}
                      className="notPrimary"
                      style={{
                        paddingLeft: '40px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                      href={p.policyUrl}
                      target="_blank"
                    >
                      <Download />
                      {p.name
                        ? t`Download` + ': ' + p.name
                        : t`Download Policy`}
                    </Link>
                  ))}
                </div>
              </div>
              {featureShowSocialShare && (
                <SocialModal>
                  <div>
                    <p>{t`Share Certificate`}:</p>
                  </div>
                  <SocilaSection>
                    <a href={linkForLinkedin} target="_blank">
                      <INLogo />
                    </a>
                    <a
                      key="fb_lnk"
                      href="https://www.facebook.com/sharer/sharer.php?u=https://easyllama.com"
                      target="_blank"
                      onClick={() => {
                        window.open(
                          'https://www.facebook.com/sharer/sharer.php?u=https://easyllama.com',
                          'pagename',
                          'resizable,height=800,width=600'
                        );
                        return false;
                      }}
                    >
                      <FBLogo />
                    </a>
                    <a
                      href={`https://twitter.com/intent/tweet?text=I just completed EasyLlama's ${title} course and I'm excited to share this modern, engaging workplace solution with my followers!&url=https://easyllama.com`}
                      target="_blank"
                      rel="noreferrer"
                      key="twitter_lnk"
                    >
                      <TwitterLogo />
                    </a>
                    {rating && rating == '5' && (
                      <a
                        href={`https://www.g2.com/products/easyllama/reviews/start`}
                        target="_blank"
                        rel="noreferrer"
                        className="G2SquareLogo"
                        key="g2_lnk"
                      >
                        <span
                          onMouseEnter={() => setTooltipVisible(true)}
                          onMouseLeave={() => setTooltipVisible(false)}
                        ></span>
                        <G2SquareLogo />
                      </a>
                    )}
                  </SocilaSection>
                  {tooltipVisible && (
                    <Tooltip placement={'left'} className={'tooltip'}>
                      {t`Write a review on G2 and send us a screenshot of the confirmation at reviews@easyllama.com`}
                      <br />
                      {t`If it is approved, we will send you a $25 Amazon gift card.`}
                    </Tooltip>
                  )}
                </SocialModal>
              )}
            </div>
            {companyContacts && companyContacts.length > 0 && (
              <div className="right-side">
                <PointOfContact title={t`Here are your points of contact`} />
              </div>
            )}
          </div>
        </Flex>
      </LlamaModal>
    </SuccessDiv>
  );
};
